import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";
import CampaignModal from "../../components/CampaignModal";
import "./styles.css";

const CampaignDisparo = () => {
  const history = useHistory();
  const { user } = useContext(AuthContext);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [campaignModalOpen, setCampaignModalOpen] = useState(false);

  const templates = [
    {
      id: "custom",
      icon: "✨",
      title: "Campanha Personalizada",
      description: "Crie uma campanha do zero com suas próprias configurações e preferências.",
      badge: "Customizável",
      badgeColor: "#e0e7ff",
      badgeTextColor: "#4f46e5",
      config: null,
    },
    {
      id: "humanized",
      icon: "👤",
      title: "Campanha Humanizada",
      description: "Envios lentos e naturais para evitar bloqueios. Ideal para campanhas de relacionamento.",
      badge: "Baixo Risco",
      badgeColor: "#dbeafe",
      badgeTextColor: "#1e40af",
      config: {
        name: "Campanha Humanizada",
        maxContacts: 30,
        intervalBetweenMessages: 120,
        delayBetweenContacts: 300,
        initialDelay: 0,
        humanized: true,
        message1: "Olá! 👋\n\nComo você está?",
        confirmation: false,
        apiType: "humanized",
      },
    },
    {
      id: "medium",
      icon: "📊",
      title: "Campanha Médio Risco",
      description: "Envios moderados com bom alcance. Equilibra velocidade e segurança.",
      badge: "Médio Risco",
      badgeColor: "#fef3c7",
      badgeTextColor: "#b45309",
      config: {
        name: "Campanha Médio Risco",
        maxContacts: 70,
        intervalBetweenMessages: 60,
        delayBetweenContacts: 180,
        initialDelay: 0,
        humanized: true,
        message1: "Olá! 👋\n\nTemos uma novidade para você!",
        confirmation: false,
        apiType: "medium",
      },
    },
    {
      id: "high",
      icon: "🚀",
      title: "Campanha Alto Risco",
      description: "Envios rápidos para máximo alcance. Maior velocidade, maior risco de bloqueio.",
      badge: "Alto Risco",
      badgeColor: "#fee2e2",
      badgeTextColor: "#dc2626",
      config: {
        name: "Campanha Alto Risco",
        maxContacts: 110,
        intervalBetweenMessages: 30,
        delayBetweenContacts: 60,
        initialDelay: 0,
        humanized: false,
        message1: "Olá! 👋\n\nNão perca essa oportunidade!",
        confirmation: false,
        apiType: "high",
      },
    },
    {
      id: "uzap-medium",
      icon: "⚡",
      title: "Uzap API Médio Risco",
      description: "Envios moderados com Uzap API. Bom equilíbrio de velocidade e segurança.",
      badge: "Médio Risco",
      badgeColor: "#fef3c7",
      badgeTextColor: "#b45309",
      config: {
        name: "Uzap API Médio Risco",
        maxContacts: 200,
        intervalBetweenMessages: 60,
        delayBetweenContacts: 60,
        initialDelay: 0,
        humanized: true,
        message1: "Olá! 👋\n\nComo você está?",
        confirmation: false,
        apiType: "uzap-medium",
      },
    },
    {
      id: "official-notification-hub",
      icon: "Ⓜ️",
      title: "WhatsApp API Oficial Meta (Notification Hub)",
      description: "API Oficial Meta via Notification Hub. Sem limites de envio, com custos por mensagem.",
      badge: "Sem Limites",
      badgeColor: "#dbeafe",
      badgeTextColor: "#1e40af",
      config: {
        name: "WhatsApp API Oficial Meta (Notification Hub)",
        maxContacts: null,
        intervalBetweenMessages: 0,
        delayBetweenContacts: 0,
        humanized: false,
        riskLevel: "official",
        message1: "Olá! 👋\n\nComo você está?",
        confirmation: false,
        apiType: "official-notification-hub",
      },
    },
    {
      id: "official-waba",
      icon: "Ⓜ️",
      title: "WhatsApp API Oficial Meta WABA",
      description: "API Oficial Meta via WABA. Sem limites de envio, com custos por mensagem.",
      badge: "Sem Limites",
      badgeColor: "#dbeafe",
      badgeTextColor: "#1e40af",
      config: {
        name: "WhatsApp API Oficial Meta WABA",
        maxContacts: null,
        intervalBetweenMessages: 0,
        delayBetweenContacts: 0,
        humanized: false,
        riskLevel: "official",
        message1: "Olá! 👋\n\nComo você está?",
        confirmation: false,
        apiType: "official-waba",
      },
    },
  ];

  const handleSelectTemplate = (template) => {
    setSelectedTemplate(template);
    setCampaignModalOpen(true);
  };

  const handleCloseCampaignModal = () => {
    setSelectedTemplate(null);
    setCampaignModalOpen(false);
  };

  return (
    <div className="campaign-disparo-container">
      <div className="campaign-disparo-header">
        <button 
          className="back-button"
          onClick={() => history.push("/campaigns")}
        >
          ← Voltar
        </button>
        <h1 className="campaign-disparo-title">🚀 Criar Nova Campanha</h1>
      </div>

      <p className="campaign-disparo-subtitle">
        Escolha um template pré-configurado e comece seu disparo em segundos. Cada opção é otimizada para um tipo específico de campanha.
      </p>

      <div className="warning-box">
        <h3 className="warning-title">⚠️ Importante</h3>
        <p className="warning-text">
          Todas as campanhas usam APIs não-oficiais ou oficiais. Quanto maior a velocidade, maior o risco de bloqueio. Sempre respeite os limites recomendados e teste com um pequeno grupo antes de fazer disparos em massa.
        </p>
      </div>

      <div className="templates-grid">
        {templates.map((template) => (
          <div key={template.id} className="template-card">
            <div className="template-icon">{template.icon}</div>
            
            <h3 className="template-title">{template.title}</h3>

            <span 
              className="template-badge"
              style={{
                backgroundColor: template.badgeColor,
                color: template.badgeTextColor,
              }}
            >
              {template.badge}
            </span>

            <p className="template-description">{template.description}</p>

            <button
              className="template-button"
              onClick={() => handleSelectTemplate(template.config)}
            >
              Usar Template
            </button>
          </div>
        ))}
      </div>

      {campaignModalOpen && (
        <CampaignModal
          resetPagination={() => {
            history.push("/campaigns");
          }}
          open={campaignModalOpen}
          onClose={handleCloseCampaignModal}
          aria-labelledby="form-dialog-title"
          templateConfig={selectedTemplate}
        />
      )}
    </div>
  );
};

export default CampaignDisparo;
